// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
// 导入页面组件
import PageNavigation from '../components/PageNavigation.vue'//首页一级页面
import OneVideo from '../components/OneVideo.vue'
import SubjectNextPageGrade from '../components/SubjectNextPageGrade.vue'//二级页面年纪
import GradeNextPageChapter from '../components/GradeNextPageChapter.vue'//三级级页面章
import PageSectionList from '../components/PageSectionList.vue'//4级级页面
import SingleVideo from '../components/SingleVideo.vue'
import PageSmartBrainHome from '../components/PageSmartBrainHome.vue'//
import EducationPlanningHome from '../components/EducationPlanningHome.vue'//
import FamilyEduHome from '../components/FamilyEduHome.vue'//
import VideoFromNet from '../components/VideoFromNet.vue'//
//import NavigationToSelfHome  from '../components/NavigationToSelfHome.vue'
//import ProfilePage from '../components/ProfilePage.vue'
const routes = [
{
	path: '/',
	name: 'Home',
	component: () => import('../components/HomePage.vue') // 首页组件
	},
{
    path: '/to-page-video-from-net',
    name: 'VideoFromNet',
    component: VideoFromNet // 首页显示导航组件
  },
{
    path: '/to-page-familyedu',
    name: 'FamilyEdu',
    component: FamilyEduHome // 首页显示导航组件
  },
  {
    path: '/PageNavigation',
    name: 'PageNavigation',
    component: PageNavigation // 首页显示导航组件
  },
  // 为每个导航项配置独立路由
  {
    path: '/brain-video',//到年级页，和上级页面设置相同才可以正确跳转
    name: 'zhiyuan',
    component: PageSmartBrainHome//年级页组件
     // 可选的元信息
  },
  {
    path: '/to-pagegrade',//到年级页，和上级页面设置相同才可以正确跳转
    name: 'math',
    component: SubjectNextPageGrade,//年级页组件
     // 可选的元信息
  },
  {
    path: '/english-video',
    name: 'english',
    component: OneVideo,
    },
  
  {
    path: '/EducationPlanning-home',
    name: 'brain',
    component: EducationPlanningHome,
    
  },
  {
    path: '/family-video',
    name: 'family',
    component: OneVideo,
     
  },
  {
    path: '/to-pagechapter',//to-pagechapter
    name: 'PageGrade',
    component: GradeNextPageChapter,
    
  },
  {
    path: '/to-pagesectionlist',
    name: 'PageSection',
    component: PageSectionList,
    
  },
 
  {
    path: '/to-singlevideo',
    name: 'PageSingleVideo',
    component: SingleVideo,
    
  }
]




// 创建路由实例
const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  routes // 路由配置
})


export default router